import env from 'env/env';

import { pathJoin } from 'utils/general';

const formatClientApiUrl = path => pathJoin(env.apiPath, path);
const formatServerApiUrl = path => pathJoin(env.serverPath, path);

const formatServerLoyaltyExperiencesServerPath = path =>
  pathJoin(env.loyaltyExperiencesServerPath, path);

const formatJohnLewisServerUrl = path => pathJoin(env.johnLewisServerPath, path);
const formatJohnLewisGiftingServerUrl = path => pathJoin(env.johnLewisGiftingServerPath, path);
const formatWalletPassesServerUrl = path => pathJoin(env.walletPassesServerPath, path);

export const formatUrl = (url, server = __SERVER__) => {
  if (server) {
    return formatServerApiUrl(url);
  }

  return formatClientApiUrl(url);
};

export const formatLoyaltyExperiencesUrl = (url, server = __SERVER__) => {
  if (server) {
    return formatServerLoyaltyExperiencesServerPath(url);
  }

  return url;
};

export const formatJohnLewisUrl = url => formatJohnLewisServerUrl(url);
export const formatJohnLewisGiftingUrl = url => formatJohnLewisGiftingServerUrl(url);
export const formatWalletPassesUrl = url => formatWalletPassesServerUrl(url);
